// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// GetDistrictsForUserHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import DistrictDTO from '../models/DistrictDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    userId: string | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            userId: '00000000-0000-0000-0000-000000000000',
        },
        initValues);
    },
    userId: 'userId',
}

interface Result extends ResultDTO {
    districts: DistrictDTO[] | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            districts: [],
        },
        initValues);
    },
    districts: 'districts',
}

export { Request, Result };